import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getBuilderChatOnboardingCookie, setBuilderChatOnboardingCookie, getOnboardingText } from '../utils';
import { selectBuilderOnboardingToForceClosing } from 'shared/selectors/chatOnboarding';
import { TBuilderChatOnboardingType } from 'shared/types/chatOnboarding';
import { useApplicationContext } from 'shared/utils/applicationContext';

interface IOnboardingTooltipResult {
  open: boolean;
  onboardingText: string;
  closeHandler: () => void;
}

const ONBOARDING_COOKIE_NAME_MAP: Record<TBuilderChatOnboardingType, string> = {
  layoutModal: 'frontend-serp.layout_builder_chat_onboarding_shown',
  newbuildingHeader: 'frontend-serp.header_builder_chat_onboarding_shown',
};

export const useBuilderChatOnboarding = (onboardingType: TBuilderChatOnboardingType): IOnboardingTooltipResult => {
  const { config } = useApplicationContext();
  const [open, setOpen] = useState(false);
  const onboardingTypeToForceClosing = useSelector(selectBuilderOnboardingToForceClosing);
  const onboardingText = getOnboardingText(config);

  const cookieName = ONBOARDING_COOKIE_NAME_MAP[onboardingType];

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    const isOnboardingEnabled = config.get<boolean>('Newbuilding.CianChatOnboarding.Enabled');

    if (isOnboardingEnabled && !getBuilderChatOnboardingCookie(cookieName)) {
      setOpen(true);
      setBuilderChatOnboardingCookie(cookieName);
    }
  }, [cookieName, config]);

  useEffect(() => {
    if (open && onboardingTypeToForceClosing === onboardingType) {
      closeHandler();
    }
  }, [open, onboardingTypeToForceClosing, onboardingType, closeHandler]);

  return {
    open,
    onboardingText,
    closeHandler,
  };
};
